import { IAIAssistantExtension } from './assistant-extension';
import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';
import componentConfigMobile from './component-config-mobile';
import { browser } from '@utils/agent';

let hasHandledExtension = false;
let aiComponent;

export async function getAiFloatComponentFromDC(): Promise<IAIAssistantExtension> {
    const arkService = ArkLoader.extensionService;
    if (!hasHandledExtension) {
        const config = browser.isMobile ? componentConfigMobile : componentConfig;
        await arkService.scanAndHandleExtensions([config]);
        hasHandledExtension = true;
        aiComponent = await ArkLoader.extensionService.getExtension(config.name) as IAIAssistantExtension;
    }
    return aiComponent;
}
